import { queryConfig } from '../../api/queryBase';
import { FilterParams } from '../../interfaces/Filter';
import { TreasuryAccount, TreasurySummary } from '../../interfaces/Treasury';
import { useQueryClient } from 'react-query';

export const useGetBank = (bankId?: number, filterOptions?: FilterParams) => {
    const query = queryConfig();
    const queryClient = useQueryClient();

    const { isLoading, data: accountData, isFetching } = query<{
        account: TreasuryAccount;
    }>({
        url: `/banks/connect/${bankId}`,
        cacheKey: `treasury-account-${bankId}`,
        params: { ...filterOptions }
    });

    const {
        isLoading: isLoadingSummary,
        data: summaryData,
        isFetching: isFetchingSummary
    } = query<TreasurySummary>({
        url: `/banks/connected/summary/${bankId}`,
        cacheKey: `treasury-account-summary-${bankId}`,
        params: { ...filterOptions }
    });

    const refetch = () => {
        queryClient.invalidateQueries({
            queryKey: [`treasury-account-${bankId}`]
        });
        queryClient.invalidateQueries({
            queryKey: [`treasury-account-summary-${bankId}`]
        });
    };

    return {
        isLoading: isLoading || isLoadingSummary,
        account: accountData?.payload.account,
        summary: summaryData?.payload,
        isFetching: isFetching || isFetchingSummary,
        refetch
    };
};
